import imagesCubemapUrl from 'url:../../../../assets/images/freedraw-cubemap-1024-3x2.webp';
import imagesGrainUrl from 'url:../../../../assets/images/grain.jpg';
import pensModelUrl from 'url:../../../../assets/models/engine.glb';
import doodleDataUrl from 'url:../../../../assets/data/doodle.cbor';

export default {
    images: {
        cubemap: imagesCubemapUrl,
        grain: imagesGrainUrl,
    },
    models: {
        pens: pensModelUrl,
    },
    data: {
        doodle: doodleDataUrl,
    },
};
